"use client"

// Last-resort boundary for errors in the root layout itself (25 Sep 2026, BOO 3840c13 parity). It replaces the root
// layout, so it renders its own <html>/<body> with inline styles (the stylesheet may not have loaded). Retry re-requests
// the page; the cart lives on the server, keyed by its cookie.

import { useEffect } from "react"

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    try {
      const body = JSON.stringify({
        kind: "boundary:global",
        path: location.pathname,
        message: String(error?.message || "error").slice(0, 400),
        stack: error?.digest ? `digest ${error.digest}` : String(error?.stack || "").slice(0, 1200),
      })
      navigator.sendBeacon?.("/api/client-error", new Blob([body], { type: "application/json" }))
    } catch {}
  }, [error])

  return (
    <html lang="en-AU">
      <body style={{ margin: 0, fontFamily: "Inter, system-ui, sans-serif", background: "#fff", color: "#111" }}>
        <div role="alert" data-testid="global-error" style={{ maxWidth: 480, margin: "15vh auto", padding: "0 16px", textAlign: "center" }}>
          <p style={{ fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", fontSize: 13 }}>Elevate Wholesale</p>
          <h1 style={{ fontSize: 24, margin: "12px 0" }}>Something went wrong — please try again</h1>
          <p style={{ color: "#555" }}>Possibly the connection dropped. Your cart is saved, so nothing is lost.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            data-testid="global-error-retry"
            style={{ marginTop: 24, height: 44, padding: "0 24px", border: 0, background: "#111", color: "#fff", fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", cursor: "pointer" }}
          >
            Retry
          </button>
        </div>
      </body>
    </html>
  )
}
